import React from "react";
import { EditableTable, createQuickRenderer } from "../../common";
import {
  useKycBeneficiariesTable,
  type IKycBeneficiariesTableProps,
} from "./useKycBeneficiariesTable";

export const KycBeneficiariesTable: React.FC<IKycBeneficiariesTableProps> = props => {
  const { beneficiaries, beneficiaryColumns, handleChange, crossIntl } = useKycBeneficiariesTable(
    props,
    createQuickRenderer,
  );
  return (
    <EditableTable
      value={beneficiaries}
      onChange={handleChange}
      columns={beneficiaryColumns}
      title={crossIntl["shareholder.table.title"]}
      addButtonText={crossIntl["shareholder.button.add"]}
      minRows={2}
    />
  );
};
